import { api } from './client';

export interface PlaybackUrl {
  mediaId: string;
  playbackUrl: string;
  contentType: string;
  expiresAt: number;
}

export async function getPlaybackUrl(mediaId: string) {
  return api.get<PlaybackUrl>(`/api/playback/${mediaId}`);
}

export async function refreshPlaybackUrl(mediaId: string) {
  return api.post<PlaybackUrl>(`/api/playback/${mediaId}/refresh`);
}
